export { SearchField as MunicipalitySearch } from './Identificator'



// WEBPACK FOOTER //
// ./src/components/identificator/index.js